import { render, staticRenderFns } from "./ReportFromRSPItem.vue?vue&type=template&id=d52de0ba&scoped=true&"
import script from "./ReportFromRSPItem.vue?vue&type=script&lang=js&"
export * from "./ReportFromRSPItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportFromRSPItem.vue?vue&type=style&index=0&id=d52de0ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52de0ba",
  null
  
)

export default component.exports